import { Module } from "vuex"
import { BaseState } from "./index"
import api from "@/services/api"

export interface FeaturesState {
	opsZendeskHelpWidgetEnabled: Boolean;
}

export const state: FeaturesState = {
	opsZendeskHelpWidgetEnabled: false
}

export const features: Module<FeaturesState, BaseState> = {
	namespaced: true,
	state,
	getters: {
		getOpsZendeskHelpWidgetEnabled: state => state.opsZendeskHelpWidgetEnabled
	},
	mutations: {
		setOpsZendeskHelpWidgetEnabled: (state: FeaturesState, widgetEnabled: boolean) => state.opsZendeskHelpWidgetEnabled = widgetEnabled
	},
	actions: {
		async getOpsZendeskHelpWidgetEnabledSetting ({ commit, getters }) {
			await api.getOpsZendeskHelpWidgetEnabledSetting().then((widgetEnabled) => {
				commit("setOpsZendeskHelpWidgetEnabled", widgetEnabled)
			})
		}
	}
}
